import {BaseAppModel} from "./AppModel";

export default class DeviceHardware extends BaseAppModel<DeviceHardware> {
    firmwareVersion?: string
    channelNumber?: number
    funNumber?: number
}
